import React from 'react'

const Name = ({
  param,
  parent
}) => {
  return (
    <label>
      <a href={ `#${encodeURI(param.anchor)}` } data-display-anchor>
        { parent?.type === 'array' && `[`}
        { parent?.key && <span>{ parent?.key }.</span> }
        { param.key }
        { parent?.type === 'array' && `]`}
      </a>
    </label>
  )
}

export default Name
